import {
  AUTHORITY_ROLE_WITH_ACCESS_BASIC,
  AUTHORITY_ROLE_WITH_ACCESS_PLUS,
  AUTHORITY_ROLE_WITH_FULL_ACCESS,
} from '../models/consts';
import { Language, User } from '../models/interfaces';
import { LOCALIZATION_LOCALE } from '../models/enums';

export class UserUtils {
  public static getFullName(user: User): string {
    let fullName = user.name || '';

    if (fullName?.length > 0 && user.surname) {
      fullName += ' ';
    }

    if (user.surname) {
      fullName += user.surname;
    }

    return fullName;
  }

  public static canUserAccessFullFeature(user: User): boolean {
    return !!user?.role && AUTHORITY_ROLE_WITH_FULL_ACCESS.includes(user?.role);
  }

  public static canUserAccessApp(user: User): boolean {
    return (
      !!user?.role && AUTHORITY_ROLE_WITH_ACCESS_BASIC?.includes(user.role)
    );
  }

  public static canUserAccessAppWithPlusFeature(user: User): boolean {
    return !!user?.role && AUTHORITY_ROLE_WITH_ACCESS_PLUS?.includes(user.role);
  }

  public static getAgbLocaleFromSelectedLanguage(lang: Language): string {
    if (lang.languageCode === LOCALIZATION_LOCALE.DE) {
      return 'de_DE';
    }

    return 'en_US';
  }
}
